module.exports = __webpack_public_path__ + "img/NotificationServiceHelp1.897917df.png";